import { managerInstance } from "libs/api";

export const requestDeleteManager = async (id: string): Promise<void> => {
  await managerInstance.delete(`/delivery-company/managers/${id}`);
};
